import { render, staticRenderFns } from "./score-room.vue?vue&type=template&id=76c04f50&scoped=true"
import script from "./score-room.vue?vue&type=script&lang=js"
export * from "./score-room.vue?vue&type=script&lang=js"
import style0 from "./score-room.vue?vue&type=style&index=0&id=76c04f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c04f50",
  null
  
)

export default component.exports